import axios from 'axios';
import { Fabric } from '../models/Fabric';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8012/api';

export const getFabrics = async (): Promise<Fabric[]> => {
  try {
    const response = await axios.get(`${API_URL}/fabrics`);
    return response.data;
  } catch (error) {
    console.error('Error fetching fabrics:', error);
    throw error;
  }
};

export const getFabricById = async (id: string): Promise<Fabric> => {
  try {
    const response = await axios.get(`${API_URL}/fabrics/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching fabric with id ${id}:`, error);
    throw error;
  }
};

export const createFabric = async (fabricData: Partial<Fabric>, imageFile?: File, swatchFile?: File): Promise<Fabric> => {
  try {
    const formData = new FormData();
    formData.append('data', JSON.stringify(fabricData));
    
    if (imageFile) {
      formData.append('image', imageFile);
    }
    
    if (swatchFile) {
      formData.append('swatch', swatchFile);
    }
    
    const response = await axios.post(`${API_URL}/fabrics`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error creating fabric:', error);
    throw error;
  }
};

export const updateFabric = async (id: string, fabricData: Partial<Fabric>, imageFile?: File, swatchFile?: File): Promise<Fabric> => {
  try {
    console.log(`[updateFabric] API çağrısı başlıyor: ID=${id}`);
    
    // Verinin doğruluğunu kontrol et ve tamamla
    const completeData = ensureCompleteData(fabricData);
    
    const formData = new FormData();
    const fabricDataString = JSON.stringify(completeData);
    formData.append('data', fabricDataString);
    
    // Dosya kontrolü ve eklenmesi
    if (imageFile) {
      console.log(`[updateFabric] Görsel dosyası ekleniyor: ${imageFile.name} (${imageFile.size} bytes)`);
      formData.append('image', imageFile);
    }
    
    if (swatchFile) {
      console.log(`[updateFabric] Kumaş örneği ekleniyor: ${swatchFile.name} (${swatchFile.size} bytes)`);
      formData.append('swatch', swatchFile);
    }

    // Axios isteğini oluştur ve gönder
    const apiUrl = `${API_URL}/fabrics/${id}`;
    console.log(`[updateFabric] Son kontroller tamam, API isteği gönderiliyor: ${apiUrl}`);
    
    // API isteği
    const response = await axios.put(apiUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    
    console.log(`[updateFabric] API yanıtı: ${response.status}`, response.data);
    return response.data;
  } catch (error: any) {
    console.error("[updateFabric] Hata yakalandı:", error);
    
    if (axios.isAxiosError(error)) {
      if (error.response) {
        console.error("[updateFabric] Sunucu hatası:", error.response.status, error.response.data);
      } else if (error.request) {
        console.error("[updateFabric] İstek gönderildi fakat yanıt alınamadı");
      }
    }
    
    throw error;
  }
};

// Eksik değerleri tamamlamak için yardımcı fonksiyon
function ensureCompleteData(data: Partial<Fabric>): Partial<Fabric> {
  return {
    ...data,
    // Temel alanlar
    name: data.name || '',
    fabricClass: data.fabricClass || '',
    type: data.type || '',
    yarnNumber: data.yarnNumber || '',
    composition: data.composition || '',
    dyeingType: data.dyeingType || 'piece_dyed',
    
    // İç içe nesne için özel kontrol
    density: {
      warp: data.density?.warp || '',
      weft: data.density?.weft || ''
    },
    
    // Sayısal değerler
    weight: data.weight || 0,
    width: data.width || 0,
    price: data.price || 0,
    minOrderQuantity: data.minOrderQuantity || 0,
    
    // Metin alanları
    notes: data.notes || '',
    description: data.description || '',
    supplier: data.supplier || '',
    leadTime: data.leadTime || '',
    stretch: data.stretch || 'Yok',
    
    // Diziler
    colors: Array.isArray(data.colors) ? data.colors : [],
    properties: Array.isArray(data.properties) ? data.properties : [],
    useCases: Array.isArray(data.useCases) ? data.useCases : []
  };
}

export const deleteFabric = async (id: string): Promise<void> => {
  try {
    await axios.delete(`${API_URL}/fabrics/${id}`);
  } catch (error) {
    console.error(`Error deleting fabric with id ${id}:`, error);
    throw error;
  }
};
